import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6ba85398 = () => interopDefault(import('../pages/culture.vue' /* webpackChunkName: "pages/culture" */))
const _573a041a = () => interopDefault(import('../pages/positions/index.vue' /* webpackChunkName: "pages/positions/index" */))
const _6724434e = () => interopDefault(import('../pages/programs.vue' /* webpackChunkName: "pages/programs" */))
const _32964a50 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _086de11b = () => interopDefault(import('../pages/positions/_id.vue' /* webpackChunkName: "pages/positions/_id" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/culture",
    component: _6ba85398,
    pathToRegexpOptions: {"strict":true},
    name: "culture"
  }, {
    path: "/positions",
    component: _573a041a,
    pathToRegexpOptions: {"strict":true},
    name: "positions"
  }, {
    path: "/programs",
    component: _6724434e,
    pathToRegexpOptions: {"strict":true},
    name: "programs"
  }, {
    path: "/en/jobs",
    component: _32964a50,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/es/trabaja-con-nosotros",
    component: _32964a50,
    pathToRegexpOptions: {"strict":true},
    name: "index___es"
  }, {
    path: "/pt-br/trabalhe-conosco",
    component: _32964a50,
    pathToRegexpOptions: {"strict":true},
    name: "index___pt-br"
  }, {
    path: "/en/jobs/culture",
    component: _6ba85398,
    pathToRegexpOptions: {"strict":true},
    name: "culture___en"
  }, {
    path: "/en/jobs/positions",
    component: _573a041a,
    pathToRegexpOptions: {"strict":true},
    name: "positions___en"
  }, {
    path: "/en/trabalhe-conosco/programas-de-carreira",
    component: _6724434e,
    pathToRegexpOptions: {"strict":true},
    name: "programs___en"
  }, {
    path: "/es/trabaja-con-nosotros/cultura",
    component: _6ba85398,
    pathToRegexpOptions: {"strict":true},
    name: "culture___es"
  }, {
    path: "/es/trabaja-con-nosotros/ofertas",
    component: _573a041a,
    pathToRegexpOptions: {"strict":true},
    name: "positions___es"
  }, {
    path: "/es/trabalhe-conosco/programas-de-carreira",
    component: _6724434e,
    pathToRegexpOptions: {"strict":true},
    name: "programs___es"
  }, {
    path: "/pt-br/trabalhe-conosco/cultura",
    component: _6ba85398,
    pathToRegexpOptions: {"strict":true},
    name: "culture___pt-br"
  }, {
    path: "/pt-br/trabalhe-conosco/programas-de-carreira",
    component: _6724434e,
    pathToRegexpOptions: {"strict":true},
    name: "programs___pt-br"
  }, {
    path: "/pt-br/trabalhe-conosco/vagas",
    component: _573a041a,
    pathToRegexpOptions: {"strict":true},
    name: "positions___pt-br"
  }, {
    path: "/",
    component: _32964a50,
    pathToRegexpOptions: {"strict":true},
    name: "index"
  }, {
    path: "/en/jobs/positions/:id",
    component: _086de11b,
    pathToRegexpOptions: {"strict":true},
    name: "positions-id___en"
  }, {
    path: "/es/trabaja-con-nosotros/ofertas/:id",
    component: _086de11b,
    pathToRegexpOptions: {"strict":true},
    name: "positions-id___es"
  }, {
    path: "/pt-br/trabalhe-conosco/vagas/:id",
    component: _086de11b,
    pathToRegexpOptions: {"strict":true},
    name: "positions-id___pt-br"
  }, {
    path: "/positions/:id",
    component: _086de11b,
    pathToRegexpOptions: {"strict":true},
    name: "positions-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
